import { API as e, Resource as t } from "@coveo/platform-client";
//#region src/resources/commerce/Synonyms.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/commerce/v2/search/synonyms`;
	}
	create(e, t) {
		return this.api.post(this.buildPath(`${n.baseUrl}`, { trackingId: t }), e);
	}
	list(e) {
		return this.api.get(this.buildPath(`${n.baseUrl}`, e));
	}
	delete(e, t) {
		return this.api.delete(this.buildPath(`${n.baseUrl}/${e}`, { trackingId: t }));
	}
	get(e, t) {
		return this.api.get(this.buildPath(`${n.baseUrl}/${e}`, { trackingId: t }));
	}
	update(e, t, r) {
		return this.api.put(this.buildPath(`${n.baseUrl}/${e}`, { trackingId: r }), t);
	}
};
//#endregion
export { n as Synonyms };

//# sourceMappingURL=Synonyms.js.map